import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const MemberEditDialog = ({ open, onOpenChange, editForm, setEditForm, onSave }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#1a1a1b] border-red-900/30 text-white">
        <DialogHeader>
          <DialogTitle className="text-red-50">Edit Data Member</DialogTitle>
          <DialogDescription className="text-gray-400">
            Edit nama marketing dan nomor HP member
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label htmlFor="edit-name" className="text-gray-300">Nama Marketing</Label>
            <Input
              id="edit-name"
              value={editForm.name}
              onChange={(e) => setEditForm({ ...editForm, name: e.target.value })}
              className="bg-[#0f0f10] border-red-900/30 text-white"
              placeholder="Masukkan nama marketing"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="edit-phone" className="text-gray-300">Nomor HP</Label>
            <Input
              id="edit-phone"
              value={editForm.phone}
              onChange={(e) => setEditForm({ ...editForm, phone: e.target.value })}
              className="bg-[#0f0f10] border-red-900/30 text-white"
              placeholder="Masukkan nomor HP"
            />
          </div>
          <div className="flex gap-3 mt-6">
            <Button
              onClick={onSave}
              className="flex-1 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800"
            >
              Simpan
            </Button>
            <Button
              onClick={() => onOpenChange(false)}
              variant="outline"
              className="flex-1 border-red-900/30 text-white hover:bg-red-900/20"
            >
              Batal
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MemberEditDialog;
